module.exports = __webpack_public_path__ + "static/media/g-5-c.d8b485ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-5-c.jpg
// module id = 1142
// module chunks = 33